import { Navigate, Outlet } from "react-router-dom";
import { useAdminMe } from "@/hooks/useAdminMe";
import AdminShell from "./AdminShell";

/**
 * Gate for the SEPARATE admin realm. Checks the admin session (GET
 * /admin-auth/me); redirects to /admin/login when unauthenticated, else renders
 * the admin shell + the matched admin route. Independent of the customer
 * `ProtectedRoute` — a customer session never grants admin access.
 */
export default function AdminProtectedRoute() {
  const { data, isLoading, isError } = useAdminMe();

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-sm text-gray-500"
        aria-busy="true"
      >
        Loading…
      </div>
    );
  }

  if (isError || !data) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <AdminShell admin={data.admin}>
      <Outlet />
    </AdminShell>
  );
}
